// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RexB","left":"styles_left__3iO6u","desktopActions":"styles_desktopActions__3Uu5S","title":"styles_title__3tTIm"};